import styled, { css } from 'styled-components'

import { Tokens } from '@/assets/tokens'

export const ComponentContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  gap: 8px;
`

export const Label = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: ${Tokens.ColorTextPrimary};
`

export const SelectionContainer = styled.div<{ $inverted: boolean }>`
  position: relative;

  width: 100%;
  height: ${Tokens.HeightInput};
  border-radius: ${Tokens.RadiusInput};
  padding: 0 16px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;

  font-size: 14px;
  font-weight: 400;
  color: ${Tokens.ColorTextPrimary};
  background-color: ${Tokens.ColorBackground};
  cursor: pointer;

  &:hover,
  &:focus-within {
    background-color: ${Tokens.ColorHover};
  }

  & > img {
    width: 1rem;
    height: 1rem;
  }

  ${({ $inverted }) =>
    $inverted &&
    css`
      background-color: ${Tokens.ColorUIPrimary};

      &:hover,
      &:focus-within {
        background-color: ${Tokens.ColorUIPrimaryDim};
      }
    `}
`

export const SelectedItem = styled.div<{ $placeholderColor: string; $hasValue: boolean }>`
  flex: 1;
  color: ${({ $placeholderColor, $hasValue }) => ($hasValue ? Tokens.ColorTextPrimary : $placeholderColor)};
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
`

export const Input = styled.input`
  all: unset;

  flex: 1;
  height: 100%;
  color: ${Tokens.ColorTextPrimary};

  &::placeholder {
    color: ${Tokens.ColorTextTertiary};
    opacity: 1; /* Firefox */
  }
`

export const SearchInput = styled.input`
  all: unset;
  flex: 1;
  font-size: 14px;
  color: ${Tokens.ColorTextPrimary};

  &::placeholder {
    color: ${Tokens.ColorTextTertiary};
  }
`

export const PortalSelectorContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  border: ${Tokens.ColorWhite} solid 0.3rem;
  border-radius: 1rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  background-color: ${Tokens.ColorBackground};
  overflow: hidden;
`

export const PortalSearchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  flex-shrink: 0;
  background-color: ${Tokens.ColorBackgroundSecondary};
  border-bottom: 1px solid ${Tokens.ColorBorder};
`

export const PortalOptionsList = styled.ul`
  all: unset;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding: 0.5rem;
  overflow-y: auto;
`

export const PortalSelectorOptions = styled.li`
  all: unset;
  display: block;
  color: ${Tokens.ColorTextPrimary};
  text-align: left;
  padding: 0.5rem;
  border-radius: 0.5rem;

  cursor: pointer;

  &:empty {
    height: 1rem;
  }

  &:hover {
    color: ${Tokens.ColorWhite};
    background-color: ${Tokens.ColorUIPrimary};
  }
`

export const IconWrapper = styled.div`
  position: relative;
  gap: 8px;
  display: flex;
  align-items: center;
`
